import * as actions from 'redux/constants';
import { getDefaultMessages, iframeMessages } from 'services/iframeService';
import { HOSTED_PAGE_TYPES } from 'consts';
import { isOTPErrorUnexpected } from 'utilities/error';

const { sendFailMsg: sendFailMessageVerifyOTP } = getDefaultMessages(
  HOSTED_PAGE_TYPES.otp
);

const otpMiddleware = store => next => action => {
  const {
    global: { isSdk }
  } = store.getState();
  if (!isSdk) {
    return next(action);
  }

  switch (action.type) {
    case actions.VERIFY_OTP_FAIL: {
      const {
        error: { error_code: errorCode }
      } = action.payload;
      sendFailMessageVerifyOTP({
        eventType: iframeMessages.VERIFY_OTP_FAIL,
        error: errorCode,
        meta: { closeIframe: isOTPErrorUnexpected(errorCode) }
      });
      break;
    }
  }

  next(action);
};

export default otpMiddleware;
